import React, { useState } from 'react';
import { Typography, Button, Box, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import CustomDialog from '../commoncomponents/CustomDialog';
import { CancelWorkOrder } from './ScmBasicDetails';
import { updateOutsourceDetails, updateWorkOrderStatus } from '../../redux/actions/workOrderActionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { mandatoryFields } from '../../redux/actions/assetActions';

const ScmBottomButtonsforWorkOrder = ({
    page = '',
    buttonAttributes,
    enableAuthorizeButton = false,
    saveButton = false,
    saveClick,
    authorizeButton = false,
    authorizeClick,
    continueButton = true,
    cancelWo = false,
    onEnableChange,
    enabel,
    onConfirm,
    outsourseSubmitBtn = false,
    outsourceHandleConfirm,
    disableSave = false,
    disableSubmitBtn = false,
    saveButtonName
}) => {
    const navigate = useNavigate();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [cancelWorkorderDialog, setCancelWorkorderDialog] = useState(false);
    const [cancel, setCancel] = useState(cancelWo);
    const findPageName = buttonAttributes.find((item) => item.currentPageName === page) || {};
    const dispatch = useDispatch();
    const { setPage, cancelButtonName, continueButtonName, backButtonName, backButton, previousPageName, cancelWO } = findPageName;

    const status = useSelector((state) => state?.workOrderStatus?.status);
    const checkcancelWOStatus = status === "Open" || status === "In Progress" || status === "In Progress-Outsource" ? true : false;

    const handleCloseCancelDialog = () => {
        setShowDeleteDialog(false);
    };

    const handleConfirmCustomCancel = (name) => {
        setCancelWorkorderDialog(false);
        if (name === 'no') {
            onEnableChange("no")
        };
    };

    const handleConfirmCancel = async () => {
        dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
        dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: {} })
        setShowDeleteDialog(false);
        navigate('/scm');
        dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    };


    const handleConfirmOutsourse = () => {
        outsourceHandleConfirm();
    };

    const handleBackClick = () => {
        setPage(previousPageName);
        dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    };

    const handleCancelClick = (e) => {
        setShowDeleteDialog(true);
    };

    const handleCustomCancelClick = (e) => {
        setCancel(e.target.name === 'cancelWo' ? true : false)
        setCancelWorkorderDialog(true);
        setCancel(false);
    };

    return (
        <>
            <Box pt={{ xs: 3, md: 8 }} sx={{ display: 'flex', justifyContent: 'space-between' }} flexWrap={'wrap'}>
                {backButton && <Box >
                    <IconButton aria-label="previous" onClick={handleBackClick} >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant='labelSm' color={'text.primary'}>{backButtonName}</Typography>
                </Box>
                }
                <Box sx={{ display: 'inline-flex', gap: 2 }}>
                    <Button variant='outlined' onClick={handleCancelClick} name='cancel' >{cancelButtonName}</Button>
                    {checkcancelWOStatus &&
                        cancelWo && <Button variant='outlined' onClick={handleCustomCancelClick} name='cancelWo' disabled={enabel}>{cancelWO}</Button>
                    }
                    {saveButton && <Button variant='contained' onClick={saveClick} disabled={disableSave}>{saveButtonName}</Button>}

                    <CancelWorkOrder
                        open={cancelWorkorderDialog}
                        onClose={handleConfirmCustomCancel}
                        onConfirm={onConfirm}
                    />
                    {outsourseSubmitBtn && <Button variant='contained' onClick={handleConfirmOutsourse} disabled={disableSubmitBtn}>Submit</Button>}
                    {
                        authorizeButton ?
                            <Button variant='contained' disabled={enableAuthorizeButton} onClick={authorizeClick}>{continueButtonName}</Button> :
                            continueButton ?
                                <Button variant='contained' disabled={enableAuthorizeButton} type="submit">{continueButtonName}</Button> : null
                    }
                </Box>
            </Box>

            <CustomDialog
                open={showDeleteDialog}
                onClose={handleCloseCancelDialog}
                onConfirm={() => { handleConfirmCancel(cancel) }}
                content="Are you sure you want to cancel?"
                cancelBtn="No"
                confirmBtn="Yes"
            />

        </>
    );
};

export default ScmBottomButtonsforWorkOrder;
